export default {
    'name': 'formulations',
    'label': 'CAS.Formulations',
    'getComponent': () => import('./Formulations.vue'),
    'tabIndex': 100,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/cas/formulations',
};
